module.exports = __webpack_public_path__ + "static/media/textile_print_01.f3e39cbf.png";